import { ProtectedResourceScopes } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Settings } from '../app/app.settings';
import { loggerCallback } from './common';

export const uatSettings: Settings = {
  baseUrl: 'https://ch-insecta-api-uat.se.research.corteva.com',
  environment: 'uat',
  isProd: false,
  appInsightsConnectionString:
    'InstrumentationKey=4f787089-1629-428a-97d3-54c1c05e7c4c;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=3e566d40-aedf-44bd-8147-17ef2308edce',
  msal: {
    config: {
      auth: {
        clientId: 'c88c59ed-f825-41a6-b46f-04c7ca0c24fa',
        authority: 'https://login.microsoftonline.com/3e20ecb2-9cb0-4df1-ad7b-914e31dcdda4/',
        redirectUri: 'https://ch-insecta-uat.se.research.corteva.com/after-login',
        postLogoutRedirectUri: 'https://ch-insecta-uat.se.research.corteva.com/after-logout',
        navigateToLoginRequestUrl: true
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Warning,
          piiLoggingEnabled: false
        }
      }
    },
    guard: {
      interactionType: InteractionType.Redirect
    },
    interceptor: {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: new Map<string, Array<string | ProtectedResourceScopes> | null>([
        ['https://ch-insecta-api-uat.se.research.corteva.com', ['api://c88c59ed-f825-41a6-b46f-04c7ca0c24fa/API.Call']]
      ])
    }
  }
};
